export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title animate">Welcome to Green Stars Services</p>
          <h1 className="hero--section--title animate">
            <span className="hero--section-title--color">A Man with a Van</span>{" "}
           
          </h1>
          <p className="hero--section-description animate">
           Reliable and friendly "Man with a Van" service with over 10 years of experience. Available for house moves, furniture transport, student relocations, and small deliveries. Based locally and fully insured. Competitive rates and flexible hours.

            <br /><mark>No job too small—call today for a free quote!</mark>
          </p>
        </div>
        
        <div className="hero-btn animate">
        <a className="btn btn-primary" href="https://wa.me/7359713227" target="_blank">Get a Quote</a>
        </div>
      
      </div>
      <div className="hero--section--img animate">
        <img className="animate" src="./img/hero-img.webp" alt="Hero Section" />
      </div>
    </section>
  );
}
